module.exports = __webpack_public_path__ + "img-front/vk.ab63d3a4.png";